// extracted by mini-css-extract-plugin
export default {"author":"Author_author__gr0wL","authorPic":"Author_authorPic__QQd9s","overlay":"Author_overlay__ivDKa"};